import { getCookie } from '@api/HelperAPI';
import { getCountry } from '@iwIntlProvider/CountryProvider';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import messages from './BankDetailsAction.messages';
import { FUNDING_STEP_ACTION } from '../../Funding.actions';
import { FundingStepActionButton } from '../fundingStepActionButton/FundingStepActionButton';
import { TFundingRequirementsSteps } from '../orderFundingRequirements';
import StepItem from '../stepItem/StepItem';
import { BankDetailsActionDE } from './BankDetailsActionDE/BankDetailsActionDE';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    handleFundingStepAction: () => {
        dispatch({ type: FUNDING_STEP_ACTION, step: 'BANK_DETAILS' });
    }
});

const BankDetailsAction = ({
    status,
    handleFundingStepAction
}: {
    status: TFundingRequirementsSteps['0']['status'];
} & ReturnType<typeof mapDispatchToProps>) => {
    const showNewDEBankAccountStep =
        getCookie('showNewDEBankAccountStep') === 'true';

    const isDE = getCountry() === 'DE';

    if (isDE && showNewDEBankAccountStep) {
        return <BankDetailsActionDE status={status} />;
    }
    return (
        <StepItem
            title={<FormattedMessage {...messages.title} />}
            caption={<FormattedMessage {...messages.caption} />}
            action={
                <FundingStepActionButton
                    actionMessage={<FormattedMessage {...messages.action} />}
                    pendingMessage={<FormattedMessage {...messages.pending} />}
                    status={status}
                    handleFundingStepAction={handleFundingStepAction}
                />
            }
        />
    );
};

// eslint-disable-next-line import/no-default-export
export default connect(null, mapDispatchToProps)(BankDetailsAction);
